import { axios } from '@Root/API'

export const getDynamic = contactId => {
	return axios.get(`/contacts/${contactId}/get-dynamic-hesa-data`)
}
